(function () {
  'use strict';
  if (typeof window === 'undefined') return;

  var REDUCE = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initCarousel(car) {
    var track = car.querySelector('[data-modulo-cp-track]');
    if (!track) return;
    var prev = car.querySelector('[data-modulo-cp-prev]');
    var next = car.querySelector('[data-modulo-cp-next]');

    function amount() {
      var card = track.querySelector('.modulo-cp__card');
      var styles = getComputedStyle(track);
      var gap = parseFloat(styles.columnGap || styles.gap || '26') || 26;
      return card ? card.getBoundingClientRect().width + gap : 320;
    }
    function sync() {
      if (!prev || !next) return;
      var scrollable = track.scrollWidth - track.clientWidth > 2;
      var max = track.scrollWidth - track.clientWidth - 2;
      prev.disabled = !scrollable || track.scrollLeft <= 2;
      next.disabled = !scrollable || track.scrollLeft >= max;
    }
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -amount(), behavior: REDUCE ? 'auto' : 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: amount(), behavior: REDUCE ? 'auto' : 'smooth' }); });
    track.addEventListener('scroll', sync, { passive: true });
    car._cpSync = sync;
    sync();
  }

  function initSection(root) {
    if (root._cpInit) return;
    root._cpInit = true;

    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-modulo-cp-tab]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-modulo-cp-panel]'));
    var cars = Array.prototype.slice.call(root.querySelectorAll('[data-modulo-cp-carousel]'));
    cars.forEach(initCarousel);

    function setTab(i) {
      i = String(i);
      tabs.forEach(function (t) {
        var on = t.getAttribute('data-modulo-cp-tab') === i;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.setAttribute('tabindex', on ? '0' : '-1');
      });
      panels.forEach(function (p) {
        var on = p.getAttribute('data-modulo-cp-panel') === i;
        p.classList.toggle('is-active', on);
        p.hidden = !on;
        if (on) {
          var track = p.querySelector('[data-modulo-cp-track]');
          if (track) track.scrollLeft = 0;
          var car = p.querySelector('[data-modulo-cp-carousel]');
          if (car && car._cpSync) car._cpSync();
        }
      });
    }

    tabs.forEach(function (t, idx) {
      t.setAttribute('tabindex', idx === 0 ? '0' : '-1');
      t.addEventListener('click', function () { setTab(t.getAttribute('data-modulo-cp-tab')); });
      t.addEventListener('keydown', function (e) {
        var dir = 0;
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') dir = 1;
        else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') dir = -1;
        else return;
        e.preventDefault();
        var target = tabs[(idx + dir + tabs.length) % tabs.length];
        target.focus();
        setTab(target.getAttribute('data-modulo-cp-tab'));
      });
    });

    var resizeTimer = null;
    window.addEventListener('resize', function () {
      if (resizeTimer) clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        cars.forEach(function (c) { if (c._cpSync) c._cpSync(); });
      }, 120);
    });
  }

  function bootstrap(scope) {
    var els = (scope || document).querySelectorAll('[data-modulo-cp]');
    for (var i = 0; i < els.length; i++) initSection(els[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { bootstrap(); });
  } else {
    bootstrap();
  }
  // Theme editor: re-init a section that was just (re)loaded.
  document.addEventListener('shopify:section:load', function (e) { bootstrap(e.target); });
})();
